import React from 'react'

const SpacingBlueItem = () => {
    return (
        <div className='hero-bottom-line-spacing hero-bottom-line-blue'></div>
    )
}

export default SpacingBlueItem